import React, { useState, useEffect } from "react";
import "./Cart.css";
import { useNavigate } from "react-router-dom";

export default function Cart() {

    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState(
        JSON.parse(localStorage.getItem("Added")) || []
    );

    const [subtotal, setSubtotal] = useState(0);
    const [adiscount, setAdiscount] = useState(0);
    const [discountInput, setDiscountInput] = useState(JSON.parse(localStorage.getItem("SelectedCoupon")) || "");



    // Recalculate subtotal whenever cart changes
    useEffect(() => {

        const newSubtotal = cartItems.reduce(
            (total, item) => total + item.price * item.quantity,
            0
        );

        setSubtotal(newSubtotal);

        if (newSubtotal === 0) {
            setAdiscount(0);
        }

    }, [cartItems]);


    // Apply discount
    const applyDiscount = (e) => {
        if (e.target.value === "") {
            setAdiscount(0);
            localStorage.removeItem("justDiscount");
            localStorage.removeItem("SelectedCoupon");
            return;
        }
        const discountarr = JSON.parse(localStorage.getItem("discountCodes")) || [];

        const discountObj = discountarr.find(
            d =>
                d._codeInput_ &&
                discountInput &&
                d._codeInput_.toLowerCase() === discountInput.trim().toLowerCase()
        );
        const userUsedCodes = JSON.parse(localStorage.getItem("UserUsedCodes") || "[]");
        const currentCode = discountObj; // the code the user is trying to apply
        if (!localStorage.getItem("userEmail")) {
            alert("Kindly! Login first to use Discount code.")
        }
        if (!discountObj) {
            alert("Invalid discount code");
            setDiscountInput("")
            setAdiscount(0);
            return;
        }

        if (userUsedCodes.includes(currentCode)) {
            alert("This discount code has already been used");
            return;
        }

        if (localStorage.getItem("userEmail")) {
            if (discountObj._codeType_ === "fixed") {
                setAdiscount(Math.min(discountObj._codeDiscount_, subtotal));
                const valuedsaved = Math.min(discountObj._codeDiscount_, subtotal)
                localStorage.setItem("justDiscount", JSON.stringify(valuedsaved));
                localStorage.setItem("SelectedCoupon", JSON.stringify(discountInput));
            }
            if (discountObj._codeType_ === "percentage") {
                const discountAmt = (subtotal * discountObj._codeDiscount_) / 100;
                setAdiscount(discountAmt);
                localStorage.setItem("justDiscount", JSON.stringify(adiscount));
                localStorage.setItem("SelectedCoupon", JSON.stringify(discountInput));
            }
        }

    };



    // Update cart in localStorage + state
    const updateCart = (newCart) => {
        localStorage.setItem("Added", JSON.stringify(newCart));
        setCartItems(newCart);
    };



    const decreaseQty = (index) => {

        let cart = [...cartItems];

        if (cart[index].quantity > 1) {
            cart[index].quantity -= 1;
        } else {
            cart.splice(index, 1);
        }

        updateCart(cart);
    };



    const increaseQty = (index) => {

        let cart = [...cartItems];
        cart[index].quantity += 1;

        updateCart(cart);
    };



    const deleteItem = (index) => {

        let cart = cartItems.filter((_, idx) => idx !== index);

        updateCart(cart);
    };



    return (
        <div className="cart">

            <div className="things">
                <div className="cart-item">

                    <table>

                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Info</th>
                                <th>Unit Total</th>
                                <th>Delete</th>
                            </tr>
                        </thead>

                        <tbody>

                            {cartItems.length > 0 ? (
                                cartItems.map((item, index) => (

                                    <tr key={index}>

                                        <td>
                                            <img src={item.img} alt={item.title} />
                                        </td>

                                        <td>

                                            <h3>{item.title}</h3>
                                            <h4>
                                                {item.color} {item.size}
                                            </h4>

                                            <p>Rs. {item.price}</p>

                                            <div className="quan">

                                                <button
                                                    className="quantity-btn-cart"
                                                    onClick={() => decreaseQty(index)}
                                                >
                                                    -
                                                </button>

                                                {item.quantity}

                                                <button
                                                    className="quantity-btn-cart"
                                                    onClick={() => increaseQty(index)}
                                                >
                                                    +
                                                </button>

                                            </div>

                                        </td>

                                        <td>
                                            Rs. {item.price * item.quantity}
                                        </td>

                                        <td>
                                            <button className="del-btn-cart" onClick={() => deleteItem(index)}>
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </td>

                                    </tr>

                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">Your cart is empty.</td>
                                </tr>
                            )}

                        </tbody>

                    </table>



                    <div className="subtotal">

                        <label className="discountbox">
                            Discount Code:
                            <input
                                type="text"
                                value={discountInput}
                                onChange={(e) => setDiscountInput(e.target.value)}
                                placeholder="Enter Discount code if any"
                            />
                            <button onClick={applyDiscount}>
                                Apply
                            </button>
                        </label>


                        <p>Subtotal: Rs. {subtotal}</p>
                        <p>Discount: Rs. -{adiscount}</p>

                    </div>

                    <h4>Total: Rs. {subtotal - adiscount}</h4>

                    <button
                        className="proceedbtn"
                        onClick={() => {
                            const items = JSON.parse(localStorage.getItem("Added")) || [];

                            if (items.length > 0) {
                                navigate("/checkout");
                            }else{
                                alert('Please! Add atleast one product to proceed to checkout')
                            }
                        }}
                    >
                        Proceed to Checkout
                    </button>

                </div>
            </div>
        </div>
    );
}